import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import NotFound404 from "components/ui/NotFound404";

export default function NotFoundUnless({ tabName, children }) {
  const hasTab = useSelector((state) => {
    const { myStatus = {} } = state;
    return myStatus[`has${tabName}Tab`] || false;
  });

  if (hasTab) {
    return children;
  }

  return (
    <Routes>
      <Route path="*" element={<NotFound404 />} />
    </Routes>
  );
}

NotFoundUnless.propTypes = {
  tabName: PropTypes.string,
  children: PropTypes.node,
};

NotFoundUnless.displayName = "NotFoundUnless";
